import { Question } from "../../../../shared/interfaces/question.interface";

export const eventsSectionQuestions: Array<Question> = [
  {
    inputFieldId: 1,
    content: "As much as you're able to share, please describe what happened step by step.",
  }
]
